'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var CID = require('cids');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var configure = require('./lib/configure');

var toIterable = require('stream-to-it/source');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _cat = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);

              if (typeof path === 'string') {
                searchParams.set('arg', path);
              } else {
                searchParams.set('arg', new CID(path).toString());
              }

              if (options.offset) searchParams.set('offset', options.offset);
              if (options.length) searchParams.set('length', options.length);
              _context.next = 7;
              return _awaitAsyncGenerator(ky.post('cat', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 7:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 10;
              _iterator = _asyncIterator(toIterable(res.body));

            case 12:
              _context.next = 14;
              return _awaitAsyncGenerator(_iterator.next());

            case 14:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 18;
              return _awaitAsyncGenerator(_step.value);

            case 18:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 26;
                break;
              }

              chunk = _value;
              _context.next = 23;
              return Buffer.from(chunk);

            case 23:
              _iteratorNormalCompletion = true;
              _context.next = 12;
              break;

            case 26:
              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 32:
              _context.prev = 32;
              _context.prev = 33;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 37;
                break;
              }

              _context.next = 37;
              return _awaitAsyncGenerator(_iterator.return());

            case 37:
              _context.prev = 37;

              if (!_didIteratorError) {
                _context.next = 40;
                break;
              }

              throw _iteratorError;

            case 40:
              return _context.finish(37);

            case 41:
              return _context.finish(32);

            case 42:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 28, 32, 42], [33,, 37, 41]]);
    }));

    function cat(_x, _x2) {
      return _cat.apply(this, arguments);
    }

    return cat;
  }();
});